import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
export function formatPlaylistAudienceAndTeams(obj) {
  if (obj.teams) {
    obj.teams = obj.teams.map(function (item) {
      return {
        id: +item.team_id,
        name: item.name,
        isSmartTeam: Boolean(+item.isSmartTeam),
        is_deleted: Boolean(+item.is_deleted),
        isCalculated: Boolean(+item.isCalculated),
        team_id: +item.team_id // backward compatibility field
      };
    });
  } else {
    obj.contentTeams || (obj.contentTeams = []);
    obj.teams = obj.contentTeams.map(function (ag) {
      var _ag$team;
      return {
        id: +ag.team.id,
        name: ag.team.name,
        isSmartTeam: Boolean(+ag.team.isSmartTeam),
        is_deleted: Boolean(+ag.team.is_deleted),
        teamType: (_ag$team = ag.team) === null || _ag$team === void 0 ? void 0 : _ag$team.teamType,
        isCalculated: Boolean(+ag.isCalculated)
      };
    });
  }
  if (obj.assetDomains && obj.assetDomains.length > 0) {
    if (obj.assetDomains[0].audience) {
      obj.audience = obj.assetDomains[0].audience;
    }
    if (obj.assetDomains[0].audienceCalculated) {
      obj.audienceCalculated = obj.assetDomains[0].audienceCalculated;
    }
  }
  return obj;
}